import { useUserRoutes } from '@cosuno/authentication-frontend';
import { useRouteMatch } from 'react-router-dom';

const useMatchesExclusionRoutes = () => {
  const routes = useUserRoutes();
  const matchesCompanyRoute = useRouteMatch(routes.company());
  const matchesCompanyPremiumRoute = useRouteMatch(routes.premium());
  const matchesSubcontractorCreateBidRoute = useRouteMatch(routes.subcontractorCreateBid());
  const matchesBidRequestDeclinePageRoute = useRouteMatch(routes.bidInviteAction());
  const matchesBidRequestLandingPageRoute = useRouteMatch({
    path: routes.bidRequestLandingPage(),
    exact: true,
  });
  const matchesBidRequestTermsPageRoute = useRouteMatch(routes.bidRequestAcceptTerms());
  const matchesAgentMarketplaceSamples = useRouteMatch(
    routes.agentUnauthenticatedMarketplaceSamples(),
  );
  const matchesReverseMarketplace = useRouteMatch(routes.reverseMarketplaceBidPackage());
  const matchesReverseMarketplaceSuggestion = useRouteMatch(
    routes.agentReverseMarketplaceSuggestion(),
  );
  const matchesMessagesRoute = useRouteMatch(routes.messages());
  const matchesAgentSignContractRoute = useRouteMatch(routes.agentSignContract());
  const matchesAgentCompanyOnboarding = useRouteMatch(routes.agentCompanyOnboarding());
  const matchesAgentCompleteRegistration = useRouteMatch(routes.agentCompleteRegistration());

  return (
    matchesCompanyRoute ||
    matchesSubcontractorCreateBidRoute ||
    matchesBidRequestDeclinePageRoute ||
    matchesBidRequestLandingPageRoute ||
    matchesBidRequestTermsPageRoute ||
    matchesAgentMarketplaceSamples ||
    matchesReverseMarketplace ||
    matchesReverseMarketplaceSuggestion ||
    matchesMessagesRoute ||
    matchesAgentSignContractRoute ||
    matchesCompanyPremiumRoute ||
    matchesAgentCompanyOnboarding ||
    matchesAgentCompleteRegistration
  );
};

export default useMatchesExclusionRoutes;
